import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ClipLoader, PropagateLoader } from 'react-spinners';
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import "jspdf-autotable";

const LeaseExpiry = () => {
    const apiService = new LeaseApiService();
    const [rowData, setRowData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [FilterTab, setFilterTab] = useState(true);
    const [propertyList, setPropertyList] = useState([]);

    const [formData, setFormData] = useState({
        property: "",
        from: "",
        to: "",
    })

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        fetchDropdownData()
        const today = new Date();
        let todate = formatDate(today)
        setFormData((prev) => ({ ...prev, to: todate, from: todate }));
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRAgreeSearchProperties');
            const res = await apiService.getApiParamater('REPORT_MULTI_DROP', `?${params.toString()}`);
            setPropertyList(res?.data?.dropdowns?.LRAgreeSearchProperties)

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            if (!formData?.property?.value?.value) {
                toast.warning("Select Property")
                setLoader(false)
                return
            }
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_EXPIRY", `?${params.toString()}`);
            if (res?.data?.result) {
                setRowData(res?.data?.result || []);
                setPagination(res.data.paginationData);
                getAllItems(res.data.paginationData)
                setLoading(false);
                setLoader(false)
            } else {
                setRowData(res?.data?.result || []);
                toast.error(res?.data?.message)
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
                setLoader(false)
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const getAllItems = async (total) => {
        try {
            setLoader(true)
            const today = new Date();
            let todate = formatDate(today)
            const params = new URLSearchParams();
            params.append("PageNo", 1);
            params.append("PageSize", total?.totalRecords);
            params.append("FromDate", formData?.from || todate);
            params.append("ToDate", formData?.to || todate);
            params.append("PropertyNo", formData?.property?.value?.value || "All");
            const res = await apiService.getApiParamater("REPORT_LEASE_EXPIRY", `?${params.toString()}`);
            if (res?.data?.result) {
                let result = res?.data?.result
                setExportData(result || []);
                setLoading(false);
                setLoader(false)
            } else {
                setLoader(false)
                setLoading(false);
            }
        } catch (error) {
            // Handle error (e.g., show error message to user)
            console.error("Error fetching items:", error);
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        { headerName: "Lease No", field: "lease_No", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Tenancy Period From", field: "lease_Date", valueFormatter: dateFormatter, comparator: dateComparator,  filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Tenancy Period To", field: "lease_Expiry", valueFormatter: dateFormatter, comparator: dateComparator,  filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Property", field: "property_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Unit No", field: "unit_No", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        {
            headerName: "Rent Per Month", field: "rentPerMonth", filter: true, floatingFilter: true, suppressMovable: true, width: 130,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
        {
            headerName: "Security Deposit", field: "security_Deposit", filter: true, floatingFilter: true, suppressMovable: true, width: 140,
            valueFormatter: (params) => (parseFloat(params.value) || 0).toFixed(3),
        },
        { headerName: "Tenant", field: "cust1_Name", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "BedRoom", field: "bedrooms", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Unit Class", field: "unit_Class", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Agent", field: "agent", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Executive", field: "finishedPreTerminated", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Area", field: "total_Area", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Type", field: "unitType", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Contact No", field: "mainContactno", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
        { headerName: "Parking", field: "parking", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
    ]
    const handleClearFilters = () => {
        const today = new Date();
        let todate = formatDate(today)
        setFormData({
            property: "",
            from: todate,
            to: todate,
        });
    }
    const handleDropDownChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value); // Ensure "DD-MMM-YYYY"
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const normalizeValue = (value) => {
        if (value === null || value === undefined) return "";
        if (value === 0 || value === "0") return ""; // keep this if you want 0 to be empty

        // Check if value is a date string in ISO format
        if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)) {
            return moment(value).format("DD-MMM-YYYY");
        }

        return value;
    };
    const exportPDF = () => {
        if (!exportData?.length) return;

        const doc = new jsPDF("landscape", "pt", "A4");

        const columns = [
            { header: "Lease No", dataKey: "lease_No", width: 100 },
            { header: "Lease Date", dataKey: "lease_Date", width: 80 },
            { header: "Expiry Date", dataKey: "lease_Expiry", width: 60 },
            { header: "Property Name", dataKey: "property_Name", width: 100 },
            { header: "Unit No", dataKey: "unit_No", width: 100 },
            { header: "Rent Per Month", dataKey: "rentPerMonth", width: 100 },
            { header: "Security Deposit", dataKey: "security_Deposit", width: 100 },
            { header: "Tenant", dataKey: "cust1_Name", width: 100 },
            { header: "BedRooms", dataKey: "bedrooms", width: 100 },
            { header: "Unit CLass", dataKey: "unit_Class", width: 100 },
            { header: "Agent", dataKey: "agent", width: 100 },
            { header: "Area", dataKey: "total_Area", width: 100 },
            { header: "Type", dataKey: "unitType", width: 100 },
            { header: "Contact No", dataKey: "mainContactno", width: 100 },
            { header: "Parking", dataKey: "parking", width: 100 },
        ];
        /* ========= HEADER ========= */

        doc.setFillColor(110, 81, 153); // #6E5199
        doc.rect(0, 0, doc.internal.pageSize.width, 50, "F");

        doc.setTextColor(255);
        doc.setFontSize(16);
        doc.text("Lease Expiry Report", 40, 32);

        doc.setFontSize(9);
        doc.text(
            `Generated unit: ${moment(formData?.to).format("DD-MMM-YYYY")}`,
            doc.internal.pageSize.width - 160,
            32
        );

        doc.setTextColor(0);

        /* ========= TABLE ========= */
        doc.autoTable({
            startY: 60,
            head: [columns.map(col => col.header)],
            body: exportData.map(row =>
                columns.map(col => normalizeValue(row[col.dataKey]))
            ),
            styles: {
                fontSize: 8,
                cellPadding: 5,
                valign: "middle",
            },
            headStyles: {
                fillColor: [110, 81, 153],
                textColor: 255,
                fontStyle: "bold",
                halign: "center",
            },
            bodyStyles: {
                halign: "center",
            },
            alternateRowStyles: {
                fillColor: [240, 237, 245],
            },
            didDrawPage: data => {
                doc.setFontSize(8);
                doc.text(
                    `Page ${data.pageNumber}`,
                    doc.internal.pageSize.width / 2,
                    doc.internal.pageSize.height - 10,
                    { align: "center" }
                );
            },
        });
        doc.save("Lease_Expiry_Report.pdf");
    };
    const exportExcel = () => {
        if (!exportData?.length) return;

        const columns = [
            { header: "Lease No", dataKey: "lease_No" },
            { header: "Lease Date", dataKey: "lease_Date" },
            { header: "Expiry Date", dataKey: "lease_Expiry" },
            { header: "Property Name", dataKey: "property_Name" },
            { header: "Unit No", dataKey: "unit_No" },
            { header: "Rent Per Month", dataKey: "rentPerMonth", type: "number" },
            { header: "Security Deposit", dataKey: "security_Deposit", type: "number" },
            { header: "Tenant", dataKey: "cust1_Name" },
            { header: "BedRooms", dataKey: "bedrooms" },
            { header: "Unit CLass", dataKey: "unit_Class" },
            { header: "Agent", dataKey: "agent" },
            { header: "Area", dataKey: "total_Area" },
            { header: "Type", dataKey: "unitType" },
            { header: "Contact No", dataKey: "mainContactno" },
            { header: "Parking", dataKey: "parking" },
        ];

        const dataRows = exportData.map(item =>
            columns.map(col =>
                col.type === "number"
                    ? Number(item[col.dataKey]) || 0
                    : normalizeValue(item[col.dataKey])
            )
        );

        const totalsRow = columns.map((col, index) => {
            if (index === 0) return "Total";
            if (col.type === "number") {
                return exportData.reduce((sum, item) => sum + (Number(item?.[col.dataKey]) || 0), 0);
            }
            return "";
        });

        const worksheet = XLSX.utils.aoa_to_sheet([
            ["LEASE EXPIRY REPORT"],
            columns.map(col => col.header),
            ...dataRows,
            totalsRow,
        ]);

        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: columns.length - 1 } },
        ];

        worksheet["!cols"] = columns.map((col, i) => {
            const maxLength = Math.max(
                col.header.length,
                ...dataRows.map(r => String(r[i] ?? "").length),
                String(totalsRow[i] ?? "").length
            );
            return { wch: Math.min(Math.max(maxLength + 3, 12), 35) };
        });

        worksheet["!rows"] = [{ hpt: 28 }, { hpt: 30 }];
        worksheet["!freeze"] = { ySplit: 2 };

        const borderStyle = {
            top: { style: "thin", color: { rgb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { rgb: "FFD9D9D9" } },
            left: { style: "thin", color: { rgb: "FFD9D9D9" } },
            right: { style: "thin", color: { rgb: "FFD9D9D9" } },
        };

        const titleCell = worksheet["A1"];
        if (titleCell) {
            titleCell.s = {
                font: { bold: true, sz: 16, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF6E5199" } },
                alignment: { horizontal: "left", vertical: "center" },
                border: borderStyle,
            };
        }

        columns.forEach((column, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: 1, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FFFFFFFF" } },
                fill: { fgColor: { rgb: "FF666666" } },
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                border: borderStyle,
            };
        });

        dataRows.forEach((row, r) => {
            columns.forEach((col, c) => {
                const cell = worksheet[XLSX.utils.encode_cell({ r: r + 2, c })];
                if (!cell) return;
                cell.s = {
                    font: { sz: 10, color: { rgb: "FF000000" } },
                    alignment: { vertical: "center", horizontal: col.type === "number" ? "right" : "left" },
                    border: borderStyle,
                };
                if (col.type === "number") {
                    cell.t = "n";
                    cell.z = "#,##0.000";
                }
            });
        });

        const totalsRowIndex = dataRows.length + 2;
        columns.forEach((col, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({ r: totalsRowIndex, c })];
            if (!cell) return;
            cell.s = {
                font: { bold: true, sz: 10, color: { rgb: "FF000000" } },
                fill: { fgColor: { rgb: "FFF0EDF5" } },
                alignment: { vertical: "center", horizontal: col.type === "number" ? "right" : "left" },
                border: borderStyle,
            };
            if (col.type === "number") {
                cell.t = "n";
                cell.z = "#,##0.000";
            }
        });

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Lease Expiry Report");
        XLSX.writeFile(workbook, "Lease_Expiry_Report.xlsx");
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"}`}>
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label className="form-label w-0">From Date</label>
                                <DatePicker
                                    selected={formData.from}
                                    onChange={(date) => handleDateChange({ name: 'from', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label w-0">To Date</label>
                                <DatePicker
                                    selected={formData.to}
                                    onChange={(date) => handleDateChange({ name: 'to', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Property <span className="text-danger">*</span></label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    isClearable
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.property}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'property', value: selectedOption })}
                                    options={propertyList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-1">
                                {loader === true ?
                                    <div className='mainbtnGry flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div onClick={() => getItems()} className="mainbtnGry flex-end gap-2 w-50">
                                        <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                }
                                <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2 w-50">
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Lease Expiry</h5>
                            <button className="btn btn-primary" onClick={exportPDF}>
                                Export as PDF
                            </button>
                            <button className="btn btn-secondary mx-3" onClick={exportExcel}>
                                Export as Excel
                            </button>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>
        </div >
    );
};
export default LeaseExpiry;